export default {
  name: "ScrollToTop",
  data: function data() {
    return {
      visible: false
    };
  },
  methods: {
    scrollTop: function scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    scrollListener: function scrollListener(e) {
      this.visible = window.scrollY > 126;
    }
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", this.scrollListener);
  }
};